import React, {useContext} from "react";
import "./Tabs.scss";
import {ThemeContext} from "../../../context/ThemeContext";
import {Theme} from "../../../models/theme.model";

export interface TabItem<T extends string> {
    id: T;
    label: string;
}

interface TabsProps<T extends string> {
    tabs: TabItem<T>[];
    activeTab: T;
    onChange: (id: T) => void;
    className?: string;
}

export function Tabs<T extends string>({tabs, activeTab, onChange, className}: TabsProps<T>) {
    const theme: Theme = useContext(ThemeContext).theme;

    return (
        <nav className={`simple-tabs ${className || ''}`}>
            {tabs.map((tab) => {
                const isActive = tab.id === activeTab;
                return <div key={tab.id}
                            className={`simple-tab ${isActive ? 'active-tab' : ''}`}
                            style={isActive ? {borderBottomColor: theme.branding_color} : undefined}
                            onClick={() => onChange(tab.id)}>
                    {tab.label}
                </div>;
            })}
        </nav>
    );
}
